import { getLabel } from '@apia/util';
import store from '../../../../../../../../store';
import { previousValidationActions } from '../../../../../../../../store/previousValidationSlice';
import { TTrConfirmProps } from '../../../components/OverrideFieldRow';
import TabsController from '../../../../../../../common/tabs/TabsController';
import { getFormsAssistantConfiguration } from '../../../getFormsAssistantConfiguration';
import { TFieldValue } from './resolveResponseResult';

const getComment = () =>
  (store.getState().previousValidationSlice.forms.executionData?.values
    ?.txtComment as string) ?? '';

export const resolveComment = (
  formName: string,
  fields: Record<string, TFieldValue>,
  toConfirm: TTrConfirmProps[],
) => {
  const commentValue = getComment();
  const formsAssistantConfigurations = getFormsAssistantConfiguration();
  if (commentValue === '') {
    store.dispatch(
      previousValidationActions.setValue({
        name: 'txtComment',
        submitValue:
          fields[formsAssistantConfigurations.OBSERVATIONS.name.toLowerCase()],
        value:
          fields[formsAssistantConfigurations.OBSERVATIONS.name.toLowerCase()],
        form: 'executionData',
      }),
    );
    TabsController.openTab('currentObservations', false);
  } else
    toConfirm.push({
      formName,
      fieldName: getLabel('sbtEjeObs').text.toLowerCase(),
      fieldTitle: getLabel('sbtEjeObs').text.toLowerCase(),
      currentValue: commentValue,
      currentValueLabel: commentValue,
      newValue:
        fields[formsAssistantConfigurations.OBSERVATIONS.name.toLowerCase()],
    });
};
